<script lang="ts" setup>

import { onMounted, ref } from '#imports';

const isLoading = ref(true);

onMounted(() => {
    isLoading.value = false;
});
</script>

<template>
  <ClientOnly>
    <template #fallback>
      <Transition name="slide-fade"
                  mode="out-in"
      >
        <slot v-if="isLoading"
              key="loading"
              name="fallback"
        ></slot>
      </Transition>
    </template>
    <Transition name="slide-fade"
                mode="out-in"
    >
      <slot v-if="!isLoading"
            key="content"
            name="default"
      ></slot>
    </Transition>
  </ClientOnly>
</template>

<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.1s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.8, 0.9, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(2px);
  opacity: 0;
}
</style>
